import { render } from "./VoiceActing.vue?vue&type=template&id=40b8b50a&scoped=true"
import script from "./VoiceActing.vue?vue&type=script&lang=js"
export * from "./VoiceActing.vue?vue&type=script&lang=js"

import "./VoiceActing.vue?vue&type=style&index=0&id=40b8b50a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b8b50a"]])

export default __exports__